if (!customElements.get('section-icon-boxes')) {
  class TG_SectionIconBoxes extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      var carouselElement = this.querySelector('[data-carousel-config]');
      if (carouselElement) {
        this.carousel = new themegoal.components.Carousel(carouselElement);
      }
    }

    disconnectedCallback(){
      if(this.carousel)this.carousel.destroy();
    }
    
  }
    
  customElements.define('section-icon-boxes', TG_SectionIconBoxes);
}

